import axios from "axios";
import { Partner_Service_URL } from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../logout/action";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const changeRMActions = {
  SAVE_CHANGE_RM_DETAILS_SUCCESS: "SAVE_CHANGE_RM_DETAILS_SUCCESS",
  SAVE_CHANGE_RM_DETAILS_ERROR: "SAVE_CHANGE_RM_DETAILS_ERROR",
};

export function saveChangeRMDetails(props) {
  const { access_token, values, partnerFirmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/changePartnerRM`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveChangeRMDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveChangeRMDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveChangeRMDetailsError(err));
          return err;
        }
      });
}

export function saveChangeRMDetailsError(error) {
  return {
    type: changeRMActions.SAVE_CHANGE_RM_DETAILS_ERROR,
    payload: error,
  };
}

export function saveChangeRMDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: changeRMActions.SAVE_CHANGE_RM_DETAILS_SUCCESS,
      payload: props,
    });
  };
}
